import {Pipe, PipeTransform} from '@angular/core';
import {format} from 'date-fns';

@Pipe({
  name: 'formatDate'
})
export class FormatDatePipe implements PipeTransform {
  transform(value: Date | string, formatDate: string, locale): string {
    if (typeof value === 'string') {
      value = new Date(value);
    }
    return format(value, formatDate, { locale });
  }
}
